// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3gfM4","cell":"ColumnAccessor_cell__3CmcN","firstCellAccent":"ColumnAccessor_firstCellAccent__1V_-n"};